import { Component } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../core/alert.service";

@Component({
  selector: 'app-invoice-notes',
  templateUrl: './invoice-notes.component.html',
  styleUrls: ['./invoice-notes.component.scss']
})
export class InvoiceNotesComponent {
  public notesInfo: string;

  isLoading: boolean = false;
  isSubmitted: boolean = false;

  constructor( private activeModal: NgbActiveModal,
    private alert: AlertService,
  ) { }

  saveNotes(): void {
    this.isSubmitted = true;

    if (!this.notesInfo) {
      this.alert.alertWarning({ title: 'Warning', text : 'Please provide additional notes.' });
      return;
    }

    this.alert.alertSuccess({ title: 'Success', text : 'Thank you! Payment process will continue...' });
    this.isSubmitted = false;
    this.close(this.notesInfo);
  }

  close(data?: any) {
    this.activeModal.close(data);
  }
}
